import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/site";
import { movies, TYPE_LABELS } from "@/lib/media";
import type { MovieType } from "@/lib/types";

const TINTS = [
  "bg-primary-50",
  "bg-accent-50",
  "bg-secondary-50",
  "bg-background-100",
];

const ICON_TINTS = [
  "bg-primary-500 text-background-50",
  "bg-accent-500 text-foreground-950",
  "bg-secondary-500 text-background-50",
  "bg-foreground-900 text-background-50",
];

export default function CategoryQuickLinks() {
  return (
    <section className="shell mt-8 md:mt-10" aria-label="影视分类">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
        {CATEGORIES.map((category, index) => {
          const count = movies.filter((movie) => movie.type === (category.key as MovieType)).length;
          return (
            <Link
              key={category.key}
              to={`/category/${category.key}`}
              className={`group cursor-pointer rounded-lg border border-background-200/80 p-4 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300 md:p-5 ${TINTS[index % TINTS.length]}`}
            >
              <div className="flex items-start justify-between">
                <span
                  className={`flex h-10 w-10 items-center justify-center rounded-md ${
                    ICON_TINTS[index % ICON_TINTS.length]
                  }`}
                >
                  <i className={`${category.icon} text-lg`} />
                </span>
                <span className="font-label text-[11px] font-semibold tracking-wide text-foreground-500">
                  {String(count).padStart(2, "0")} 部
                </span>
              </div>
              <h3 className="mt-3 flex items-center gap-1.5 text-[15px] font-bold text-foreground-950">
                {category.label}
                <span className="font-label text-[10px] font-medium uppercase tracking-[0.14em] text-foreground-400">
                  {category.en}
                </span>
              </h3>
              <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">{category.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-700">
                进入{TYPE_LABELS[category.key as MovieType]}专区
                <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-0.5" />
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}